import React from "react";
import styled from "styled-components";
import TransHTML from "~components/transHTML";
import {RatingByStars} from "~components/reviews/stars";
import {smallScreenBreakpoint1064px, tabletBreakpoint} from "~styles/common";
import {UserReviewItemType} from "~components/reviews/types";

type PropTypes = {
    item: UserReviewItemType;
};

// really similar to "MerchantReviewItem" let's try to merge them / create parent component
export function UserReviewItem({ item }: PropTypes) {
    return (
        <Wrapper>
            <Owner>
                <UserImg>{item.userImg}</UserImg>
                <UserName>
                    <TransHTML id={item.userName} />
                </UserName>
                <Location>📍</Location>
                <UserLocation>
                    <TransHTML id={item.location} />
                </UserLocation>
            </Owner>
            <Text>
                <TransHTML id={item.userComment} />
            </Text>
            <Bottom>
                <RatingByStars review={item.stars} />
            </Bottom>
        </Wrapper>
    );
}

const Location = styled.span`

`;

const Owner = styled.div`
    display: flex;
    align-items: center;
    gap: .9rem;
`;

const UserName = styled.h3`
    font-size: 1rem;
    font-weight: 700;
    margin-bottom: 0;
`;

const UserLocation = styled.span`
    font-size: 1rem;
    font-weight: 700;
    margin-bottom: 0;
`;

const Bottom = styled.div`
    display: flex ;
    justify-content: space-between;
`;

const Stars = styled.div`
    display: flex;
    gap: 5px;
    padding: .4rem 1rem ;
    box-shadow: 2px 2px 14px rgba(0, 0, 0, 0.21);
    border-radius: 52px;
`;

const UserImg = styled.span`
    display: block;
    font-size: 22px;
`;

// todo: fix margin!
const Wrapper = styled.div`
    background: #FAFAFA;
    border-radius: 16px;
    padding: 1rem;
    margin: 0 .5rem;
    text-align: left;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 1rem;

    @media (min-width: ${tabletBreakpoint}) {
        padding: 2rem;
        max-width: none;
        min-height: 480px;
        gap: 0;
    }

    @media (min-width: ${smallScreenBreakpoint1064px}) {
        margin: 0 2rem;
        padding: 2.5rem;
        max-width: 400px;
    }
`;

const Text = styled.div`
    font-weight: 400;
    font-size: 1.1rem;
    line-height: 1.5;
    width: 100%;

    @media (min-width: ${tabletBreakpoint}) {
        max-width: 400px;
    }
`;
